'use client'
import { useInfiniteQuery } from '@tanstack/react-query'
import { IListPostReviewProps } from '../types/review'
import { reviewService } from '../services'

export const useInfiniteReviews = ({ productId, options, enabled = true, params }: IListPostReviewProps) => {
  return useInfiniteQuery({
    queryKey: ['listReview', productId, params],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await reviewService.getListReview({
        params: {
          currentPage: pageParam,
          pageSize: params?.pageSize || 10,
          rating_stars: params?.rating_stars,
        },
        productId,
        options,
      })
      if (res?.status === 'success' && res?.data) {
        return res?.data
      }
      return null
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage) return undefined
      const totalReviews = lastPage.total_count || 0
      const loadedReviews = allPages.reduce((acc, page) => acc + (page?.items?.length || 0), 0)

      // Nếu còn reviews để load thì return page tiếp theo
      if (loadedReviews < totalReviews) {
        return allPages.length + 1
      }
      return undefined
    },
    initialPageParam: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    enabled: !!productId && enabled,
  })
}
